const routes = {
  root: "/",
  ideaSubmit: "/submit",
};

export default routes;
